var exports = {
  "h": "xe7b6e3d6--336b37--description",
  "Q": "xe7b6e3d6--336b37--text",
};

module.exports = exports;
